import React from 'react';
import { Box, Image, Text } from '@chakra-ui/react';

import chatBubble from '../../../chat-bubble.png';
import infoMac from '../../../info-mac.png';

const OcrInfoBubble = () => (
  <Box height="400px" position="relative" width="100%">
    <Box height="auto" margin="0 auto" position="relative" width="430px">
      <Image margin="0 auto" src={chatBubble} width="430px" />
      <Box
        color="primaryScale.500"
        left="15%"
        position="absolute"
        textAlign="center"
        top="23%"
        width="315px"
        zIndex={6}
      >
        <Text fontWeight="500">
          PINS uses AI to find acord forms in your uploaded documents and extract policy data.  Sit back and relax while we do the work for you!
        </Text>
      </Box>
      <Image bottom="-75px" left="-10%" position="absolute" src={infoMac} />
    </Box>
  </Box>
);

export default OcrInfoBubble;
